module.exports = __webpack_public_path__ + "img/levelup-logo-blue.36c731d0.svg";